module.exports = __webpack_public_path__ + "img/card-4.fb30c107.png";